module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0114.jpg?v=078462e2";